const LANGUAGES = {
  en: {
    defaultMessage: 'English',
    id: 'locale.language.en',
  },
  es: {
    defaultMessage: 'Spanish',
    id: 'locale.language.es',
  },
  fr: {
    defaultMessage: 'French',
    id: 'locale.language.fr',
  },
  nl: {
    defaultMessage: 'Nederlands',
    id: 'locale.language.nl',
  },
};

export default LANGUAGES;



// WEBPACK FOOTER //
// ./client/src/javascript/constants/Languages.js